import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

body {
    margin: 0;
    padding: 0;
    background: #EFEFEF;
    font-family: 'Rubik', sans-serif;
    width: 100vw;
    height: 100vh;
  }

a {
  color: inherit;
  text-decoration: none;
}

`;



export default GlobalStyle;
